export default __webpack_public_path__ + "static/media/the_high_priestess.7a47a840.png";